import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ComponentPageTitle } from '../../page-title/page-title.component';
import { AppServiceService } from '../../services/app-service.service';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { CreatecampanaComponent } from 'src/app/home/createcampana/createcampana.component';
import { ModifyCampanaComponent } from 'src/app/home/modify-campana/modify-campana.component';
import { CreateScheduleComponent } from 'src/app/home/create-schedule/create-schedule.component';
import { CreateAlarmaComponent } from 'src/app/home/create-alarma/create-alarma.component';
import { CreateCriterioComponent } from 'src/app/home/create-criterio/create-criterio.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfigService } from 'src/app/services/config.service';
import { Subscription } from 'rxjs/Subscription';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CreateCicloComponent } from 'src/app/home/create-ciclo/create-ciclo.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { PasswordnewComponent } from 'src/app/login/passwordnew/passwordnew.component';
import { DuplicarCampanaComponent } from './duplicar-campana/duplicar-campana.component';
import * as AWS from 'aws-sdk';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-campana',
	templateUrl: './campana.component.html',
	styleUrls: ['./campana.component.scss']
})
export class CampanaComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

	private s3: AWS.S3;

	estados = [
		{ id: 1, nombre: 'TOTAL CLIENTES', cantidad: 0 },
		{ id: 2, nombre: 'GESTIONADOS', cantidad: 0 },
		{ id: 3, nombre: 'AGENDADOS', cantidad: 0 },
		{ id: 4, nombre: 'PENDIENTE DE GESTIÓN', cantidad: 0 },
		{ id: 5, nombre: 'RECUPERADOS', cantidad: 0 },
	]

	// campanaColumns: string[] = ['NOMBREEJE', 'NOMBRE', 'MEDIO', 'VIGENCIAINICIAL', 'VIGENCIAFINAL', 'PAIS', 'ACCION'];
	//campanaColumns: string[] = ['NOMBREEJE', 'NOMBRE', 'MEDIO', 'VIGENCIAINICIAL', 'VIGENCIAFINAL', 'ACCION'];
	campanaColumns: string[] = ['NOMBREEJE', 'NOMBRE', 'MEDIO', 'ESTADO', 'CREACION', 'VIGENCIAINICIAL', 'VIGENCIAFINAL', 'CANTCLIENT', 'ACCION'];
	dataSource = new MatTableDataSource<any>([]);
	FILTER: string = '';
	resultsLength: number = 0;
	pageSize = 10;
	private subscription: Subscription;
	private subscriptioncreate: Subscription;
	private subscriptionpais: Subscription;
	idpais;
	pageEvent: PageEvent;
	public actpage: number = 0;
	activo = 1;

	selectedRow: any = null;

	constructor(
		private router: Router,
		private snackbar: MatSnackBar,
		private gateway: GatewayService,
		public pageTitle: ComponentPageTitle,
		public _appservice: AppServiceService,
		public _busqueda: BusquedaService,
		public _create: CreateService,
		private dialog: MatDialog,
		public _filtroPais: FiltroPaisService,
		private localSave: LocalSaveService,
		private spinner: NgxSpinnerService,
		private configService: ConfigService
	) {
		const awsCfg = this.configService.getAwsConfig();
		AWS.config.update({
			accessKeyId: awsCfg ? awsCfg.accessKeyId : '',
			secretAccessKey: awsCfg ? awsCfg.secret : '',
			region: (awsCfg ? awsCfg.region : '') || 'us-east-1'
		});
		this.s3 = new AWS.S3({
			params: {
				Bucket: 'socialmanager/importleads'
			}
		});
	}

	@ViewChild('campanapaginator') campanapaginator: MatPaginator;

	ngOnInit() {
		const user = this.localSave.get('usuarioPGV');
		// alert(user.idrol)
		if (user && user.idrol == 10) {
			// this.router.navigate(['/home/administrador']);
		}
		else if (user && user.idrol == 16) {
			this.router.navigate(['/home/campanaadmin']);
		}
		else if (user && user.idrol == 17) {
			this.router.navigate(['/homeagente/botonera']);
		} else {
			this.router.navigate(['/home']);
		}
		this.idpais = this.localSave.get('pais');
		this.get(0);
		this.pageTitle.title = 'Campañas';
		// this.loadUsuarios();
		this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.filtrarcampana(res.filtro);
			});
		this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				// console.log(res);
				this.createCampana();
			});
		this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				// console.log(res);
				this.idpais = res.IDPAIS;
				this.get(0);
			}
		);
	}

	filtrarxEstado(estado: any) {
		// this.snackbar.open(`Estado: ${estado.id}`, 'Cerrar', { duration: 3000, });
		this.activo = estado.id;
		this.get(this.actpage);
	}

	// ============== FILTRO ==============
	filter = '';
	public keyDownFunction(event) {
		if (event.keyCode == 13) {
			this.filtrogeneral();
		} else if (event.keyCode == 8 && this.filter == '') {
			this.filtrogeneral();
		}
	}
	public filtrogeneral() {
		this._busqueda.notificarBusqueda({ filtro: this.filter });
	}

	ngAfterViewInit() {
		// console.log(this.localSave.get('nuevoUserPass'))

		if (this.localSave.get('nuevoUserPass') == 0) {
			setTimeout(() => {
				this.openPassword();
			})

		}
	}

	get(page) {
		let params = {
			ACTIVO: this.activo,
			NUM_PAGINA: page,
			FILTRO: this.FILTER,
			NUM_ELEMENTOS: this.pageSize,
			IDPAIS: this.idpais,
			IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU,
		};
		this.spinner.show();
		this.gateway.get('getcampana', params).then((result: any) => {
			const campanias = result.rows;
			if (campanias.length > 0) {
				campanias.forEach((campania) => {
					campania.vigenciainicial = new Date(campania.vigenciainicial);
					campania.vigenciafinal = new Date(campania.vigenciafinal);
				});
			}
			this.dataSource = new MatTableDataSource(campanias);
			this.gateway.get('getcampanacount', params).then((result: any) => {
				this.resultsLength = result.rows[0].total;
				this.gateway.get('getcampanasemaforoclientes', params).then((result: any) => {
					let resultado = result.rows[0];
					const mapeoEstados = [
						{ indice: 0, propiedad: 'total_clientes' },
						{ indice: 1, propiedad: 'total_gestionados' },
						{ indice: 2, propiedad: 'total_agendados' },
						{ indice: 3, propiedad: 'total_pendientes' },
						{ indice: 4, propiedad: 'total_exitosas' },
					];
					mapeoEstados.forEach(({ indice, propiedad }) => {
						this.estados[indice].cantidad = resultado[propiedad] || 0;
					});
					this.spinner.hide();
				});
			});
		}).catch(function (e) { });
	}

	onRowClick(row: any): void {
		if (this.selectedRow === row) {
			this.selectedRow = null;
			this.resetEstados();
		} else {
			// Seleccionar el nuevo registro
			this.selectedRow = row;
			this.obtenerDatosPorCampana(row.idcampana);
		}
	}

	obtenerDatosPorCampana(idCampana: number): void {
		const params = {
			IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU,
			IDCAMPANA: idCampana,
		};

		this.gateway.get('getcampanasemaforoclientesporcampana', params).then((result: any) => {
			const resultado = result.rows[0];
			const mapeoEstados = [
				{ indice: 0, propiedad: 'total_clientes' },
				{ indice: 1, propiedad: 'total_gestionados' },
				{ indice: 2, propiedad: 'total_agendados' },
				{ indice: 3, propiedad: 'total_pendientes' },
				{ indice: 4, propiedad: 'total_exitosas' },
			];

			mapeoEstados.forEach(({ indice, propiedad }) => {
				this.estados[indice].cantidad = resultado[propiedad] || 0;
			});

		}).catch((error) => {
		});
	}

	resetEstados(): void {
		this.estados = [
			{ id: 1, nombre: 'TOTAL CLIENTES', cantidad: 0 },
			{ id: 2, nombre: 'GESTIONADOS', cantidad: 0 },
			{ id: 3, nombre: 'AGENDADOS', cantidad: 0 },
			{ id: 4, nombre: 'PENDIENTE DE GESTIÓN', cantidad: 0 },
			{ id: 5, nombre: 'RECUPERADOS', cantidad: 0 },
		];
		this.get(this.actpage);
	}

	isSelected(row: any): boolean {
		return this.selectedRow === row;
	}

	ngOnDestroy() {
    if (this.destroy$) {
      this.destroy$.next();
      this.destroy$.complete();
    }
		if (this.subscription) { this.subscription.unsubscribe(); }
		if (this.subscriptioncreate) { this.subscriptioncreate.unsubscribe(); }
		if (this.subscriptionpais) { this.subscriptionpais.unsubscribe(); }
	}

	createCampana() {
		const dialogRef = this.dialog.open(CreatecampanaComponent, {
			width: '80%',
			height: '94%',
			data: { IDPAIS: this.idpais },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
			this.get(this.actpage);
		});
	}

	cambioElementos(event?: PageEvent) {
		this.actpage = event.pageIndex;
		this.get(event.pageIndex);
	}

	addSchedule(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateScheduleComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			//console.log('The dialog was closed');
		});
	}

	editarCamapana(campana) {
		campana['IDPAIS'] = this.idpais;
		const dialogRef = this.dialog.open(ModifyCampanaComponent, {
			width: '80%',
			height: '94%',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			//console.log('The dialog was closed');
			//if (result) {
			this.get(this.actpage);
			//}
		});
	}

	addAlarm(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateAlarmaComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	addCiclo(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateCicloComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '50vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	addCriterio(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateCriterioComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	delete(element) {
		//console.log(element)

		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deletecampana', id: { IDCAMPANA: element.idcampana } }
		});

		dialogRef.afterClosed().subscribe(() => {
			this.campanapaginator.firstPage();
			this.get(0);
		});
	}

	enviarPlantillas(element) {
		//console.log(element)
		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { sms: 'enviar plantilla a los clientes', addcomment: false }
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result.resp) {
				this.gateway.get('sendplantillascampana', {
					id_campana: element.idcampana
				}).then((result: any) => {
					this.get(this.actpage);
					this.snackbar.open(result.message, 'Cerrar', { duration: 10000, });
				});
			}
		});
	}

	filtrarcampana(data) {
		this.FILTER = data;
		this.get(0);
	}

	// exportar(campana) {
	// this.spinner.show();
	// 

	// 	//console.log('ASDF');
	// 	console.log(campana.IDCAMPANA);
	// 	this.gateway.get('exportarlista', { IDCAMPANA: campana.IDCAMPANA }).then(

	exportar(campana) {
		this.spinner.show();
		this.gateway.get('exportarlistacount', { IDCAMPANA: campana.idcampana }).then(
			(data: any) => {
				if (data.rows[0].cantidad > 0) {
					this.prepararinformacion(campana, data.rows[0].cantidad, 0, null);
				} else {
					this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
					this.spinner.hide();
				}
			}
		);
	}

	// =================================================================================================================
	// ========================================= CARGAR ARCHIVO XLSX ===================================================
	// =================================================================================================================
	public file; valor;
	openInput(campana) {
		this.localSave.set('campana', campana.idcampana);
		document.getElementById("fileInput100").click();
	}

	ObtenerArchivoCarga(event) {
		this.file = event.target.files[0];
		this.valor = this.file.name;
		if (typeof (this.file != "undefined")) {
			this.cargarLista();
		}
	}

	params: any;
	cargarLista() {
		this.spinner.show();
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
			/* save data */
			const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
			// (<HTMLInputElement>document.getElementById('fileInput100')).value = null;

			let filename = Date.now() + '_' + this.valor;
			this.params = {
				Key: filename,
				Body: this.file,
				ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				ACL: 'public-read'
			};

			this.s3.upload(this.params, function (err, data) {
				if (err) {
				} else {
					(<HTMLInputElement>document.getElementById('fileInput100')).value = null;
				}
			});

			this.loadlistxls(dataexcel, ("https://s3.amazonaws.com/socialmanager/importleads/" + filename).trim(), this.valor);
		};
		reader.readAsBinaryString(this.file);
	}

	async loadlistxls(data, urlfinal, nombrearchivo) {
		this.spinner.show();
		let keys = data.splice(0, 1)[0];
		// console.log('keys:');
		// console.log(keys);
		// console.log('data:');
		// console.log(data);
		let dataConvert: any = this.convertirArreglo(data, keys);
		if (dataConvert.length) {
			this.snackbar.open('Iniciado: el proceso a comenzado.', 'Cerrar', { duration: 3000, });
		} else {
			this.spinner.hide();
			return;
		}

		const totaldatos = dataConvert;
		const cantini = dataConvert.length;
		dataConvert = dataConvert.filter(gestion => gestion.cc_campaign_id == this.localSave.get('campana'));
		const cantfin = dataConvert.length;
		let cantidad_insertados = 0;

		sendLista(0, this.gateway, this.localSave.get('campana'), this.spinner, this.snackbar, urlfinal, nombrearchivo, totaldatos, this);
		function sendLista(cantidad, gatew, idcampana, localspinner, localsnack, urlfinal, nombrearchivo, totaldatos, this2) {
			const that = this2;
			let auxarr = [];
			auxarr = dataConvert.slice(cantidad, cantidad + 100);

			gatew.save('insert_datos_gestiones', { DATOS: auxarr, IDCAMPANA: idcampana, NOMBRE: nombrearchivo, CONTENIDO: totaldatos, CONTENIDO_FILTRADO: dataConvert, URLFINAL: urlfinal, INICIO: cantidad }).then(
				res => {
					if ((cantidad + 100) < dataConvert.length) {
						cantidad_insertados += res.cantidad_insertados;
						localsnack.open(`En Proceso: Se han insertado ${(cantidad + 100)} Cliente(s).`, 'Cerrar', { duration: 3000, });
						sendLista(cantidad + 100, gatew, idcampana, localspinner, localsnack, urlfinal, nombrearchivo, totaldatos, this2)
					} else {
						cantidad_insertados += res.cantidad_insertados;
						// localsnack.open(`Finalizado: Han sido cargados ${cantfin} gestione(s) con éxito de ${cantini}.`, 'Cerrar', { duration: 7000, });
						localsnack.open(`Finalizado: Han sido cargados ${cantidad_insertados} gestione(s) con éxito de ${cantini}.`, 'Cerrar', { duration: 7000, });
						localspinner.hide();
					}
				},

				err => {
					localsnack.open('ERROR: las gestiones no han sido cargadas, intente nuevamente.', 'Cerrar', { duration: 3000, });
					localspinner.hide();
					// console.log(err);
				}
			);

		}
	}

	convertirArreglo(data, keys) {
		// let keys = data.splice(0, 1)[0];
		// console.log(keys);
		let ret = [];
		try {
			data.forEach(element => {
				const obj: any = {};
				for (let index = 0; index < element.length; index++) {
					let aux: string = keys[index];
					aux = aux.replace('"', '').trim();
					aux = aux.toString().replace(/'/g, "");
					obj[aux] = element[index];
					// obj[aux] = obj[aux] ? this.excelDateToJSDate(aux, obj[aux]) : obj[aux]
					obj[aux] = obj[aux] ? this.excelDateToJSDate1(aux, obj[aux]) : obj[aux]
				}
				if (obj.phone_number) {
					let str = obj.phone_number;
					if (!isNaN(str)) {
						obj._IDTELEFONOCAMPANA = `${obj.phone_number}${obj.cc_campaign_id}`;
						ret.push(obj);
					}
				}
			});
			if (ret.length && (ret[0].phone_number && ret[0].cc_campaign_id)) {
				return ret;
			} else {
				this.snackbar.open('Archivo no válido, Las columnas phone_number y cc_campaign_id son obligatorias.', 'Cerrar', { duration: 3000, });
				return [];
			}
		} catch (e) {
			this.spinner.hide();
			this.snackbar.open('Archivo no válido intente de nuevo.', 'Cerrar', { duration: 3000, });
			return null;
		}
	}

	excelDateToJSDate(aux, excelDate) {
		if (aux == 'call_start_dt' || aux == 'call_end_dt' || aux == 'open_dt' || aux == 'failed_dt' || aux == 'received_dt' || aux == 'dt' || aux == 'reschedule_dt') {
			const date = new Date(1900, 0, excelDate - 1);  // Ajuste para el día base de Excel
			const days = Math.floor(excelDate);
			const secondsInDay = (excelDate - days) * 86400; // 86400 segundos en un día
			date.setSeconds(secondsInDay);
			let strdate = `${date.getFullYear()}-${this.dosDig(date.getMonth() + 1)}-${this.dosDig(date.getDate())} ${this.dosDig(date.getHours())}:${this.dosDig(date.getMinutes())}:${this.dosDig(date.getSeconds())}`
			return strdate;
		}
		return excelDate;
	}

	excelDateToJSDate1(aux, excelDate) {
		if (aux == 'call_start_dt' || aux == 'call_end_dt' || aux == 'open_dt' || aux == 'failed_dt' || aux == 'received_dt' || aux == 'dt' || aux == 'reschedule_dt') {

			const moment = require('moment');
			// Fecha en formato "DD/MM/YYYY hh:mm:ss"
			const fechaOriginal = excelDate;
			// Convertir al formato "YYYY-MM-DD hh:mm:ss"
			const fechaConvertida = moment(fechaOriginal, "DD/MM/YYYY hh:mm:ss").format("YYYY-MM-DD HH:mm:ss");
			// const fechaConvertida = moment(fechaOriginal, "MM/DD/YYYY hh:mm:ss").format("YYYY-MM-DD HH:mm:ss");
			return fechaConvertida;
		}
		return excelDate;
	}

	dosDig(num) {
		return num < 10 ? `0${num}` : num;
	}

	// =================================================================================================================
	// =================================================================================================================

	duplicar(campana) {
		const dialogRef = this.dialog.open(DuplicarCampanaComponent, {
			disableClose: true,
			width: '450px',
			data: campana
		});

		dialogRef.afterClosed().subscribe(() => {
			this.get(this.actpage);
		});
	}

	prepararinformacion(campana, count, index, data) {
		this.gateway.get('exportarlistalote', { IDCAMPANA: campana.idcampana, LIMIT: 100, OFFSET: index }).then(
			(result: any) => {
				if (data) {
					data = data.concat(result.rows)
				} else {
					data = result.rows;
				}
				let control = index + 100;
				if (control <= count) {
					this.prepararinformacion(campana, count, control, data);
				} else {
					this.descargarexcel(data, campana);
				}
			}
		);
	}

	descargarexcel(ctr, campana) {
		const fileName = 'Campana' + campana.nombre + '-' + Date.now();
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
		XLSX.utils.book_append_sheet(wb, ws);

		const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
		saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
		this.spinner.hide();
	}

	public async openPassword() {
		const agente = this.localSave.get('usuarioPGV');
		let dialogRef = await this.dialog.open(PasswordnewComponent, {
			width: '450px',
			disableClose: true,
			data: { title: 'Cambio de contraseña', agente: { idagente: agente.IDU } }
		});

		dialogRef.afterClosed().subscribe(result => {
		});
	}

	//----------------ASIGNA MASIVO------------------

	asignaMasivo() {
		document.getElementById("uploadfileasigna").click();
	}

	onFileChangeAsigna(evt: any) {
		let LISTA = [];

		this.spinner.show();

		let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

		// console.log(uploadname);

		/*    this.openclose=false;*/
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
			/* save data */
			const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
			(<HTMLInputElement>document.getElementById('uploadfileasigna')).value = null;
			// console.log(dataexcel);
			let csv = [];
			let flag = dataexcel[0];
			const bandera: number = 0;

			//validar columnas

			if (flag[0] === 'USUARIO' && flag[1] === 'CAMPAÑA' && flag[2] === 'CONTACTO' && flag[3] === 'EFECTIVIDAD'
				&& flag[4] === 'CONVERSION' && flag[5] === 'TMO(SEG)' && flag[6] === 'LLAMADAS' && flag[7] === 'CONTACTOS EFECTIVOS') {
				dataexcel.forEach((value) => {
					if (value[0] != 'USUARIO' && value[0] != '' && value[0] != undefined
						&& value[1] != 'CAMPAÑA' && value[1] != '' && value[1] != undefined
						&& value[2] != 'CONTACTO' && value[2] != '' && value[2] != undefined
						&& value[3] != 'EFECTIVIDAD' && value[3] != '' && value[3] != undefined
						&& value[4] != 'CONVERSION' && value[4] != '' && value[4] != undefined
						&& value[5] != 'TMO(SEG)' && value[5] != '' && value[5] != undefined
						&& value[6] != 'LLAMADAS' && value[6] != '' && value[6] != undefined
						&& value[7] != 'CONTACTOS EFECTIVOS' && value[7] != '' && value[7] != undefined) {
						LISTA.push({
							USUARIO: value[0], CAMPANA: value[1], CONTACTO: value[2], EFECTIVIDAD: value[3]
							, CONVERSION: value[4], TMO: value[5], LLAMADAS: value[6], CONTACTOS: value[7]
						});
					}
				});
				this.loadlistxlsAsigna(LISTA, 0);
			} else {
				this.snackbar.open('Formato de archivo no válido, porfavor intente con otro archivo.', 'CERRAR', { duration: 6000 });
				this.spinner.hide();
			}
		};
		reader.readAsBinaryString(target.files[0]);
	}

	loadlistxlsAsigna(LISTA, cantidad) {
		this.spinner.show();
		let auxarr = [];
		auxarr = LISTA.slice(cantidad, cantidad + 300);
		this.gateway.save('asignamasivaagentes', { IDCAMPANA: 10, LISTA: auxarr, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then(
			res => {
				const resultado: any = res;
				if ((cantidad + 300) < LISTA.length) {
					this.loadlistxlsAsigna(LISTA, cantidad + 300);
				} else {
					this.spinner.hide();
					this.snackbar.open('Campañas asignadas con éxito: ' + resultado.agregados + ', campañas no asignadas: ' + resultado.noagregados, 'Cerrar', { duration: 5000, });
					this.get(this.actpage);
				}
			},
			err => {
				this.spinner.hide();
				this.snackbar.open('Los agentes no han sido asignados, intente nuevamente.', 'Cerrar', { duration: 5000, });
				// console.log(err);
			}
		);
	}

	//----------------ENVIAR ENCUESTA MASIVO------------------
	id_campana_envencuesta = null;
	envencuestamasivo(element) {
		this.id_campana_envencuesta = element.idcampana;
		document.getElementById("uploadfileenvencuesta").click();

	}

	onFileChangeEnvEncuesta(evt: any) {
		let LISTA = [];

		this.spinner.show();

		let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

		// console.log(uploadname);

		/*    this.openclose=false;*/
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) {
			// throw new Error('Cannot use multiple files');
			this.spinner.hide();
			return this.snackbar.open('No se permite seleccionar multiples archivos.', 'Cerrar', { duration: 7000, });
		}

		// ✅ Obtener el nombre del archivo XLSX
		const fileName = target.files[0].name;

		const extension = fileName.split('.').pop();
		if (extension !== 'xlsx') {
			this.snackbar.open('El archivo debe ser un Excel (.xlsx)', 'Cerrar', { duration: 5000 });
			this.spinner.hide();
			return;
		}

		const reader: FileReader = new FileReader();
		reader.onload = async (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
			/* save data */
			const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
			(<HTMLInputElement>document.getElementById('uploadfileenvencuesta')).value = null;
			// console.log(dataexcel);
			let csv = [];
			const flag = dataexcel[0];
			const bandera: number = 0;

			let keys = dataexcel.splice(0, 1)[0];
			const dataConvert: any = this.convertir_a_Arreglo(dataexcel, keys);

			if (dataConvert) {
				const id_campana_envencuesta = this.id_campana_envencuesta;
				const timestamp = Date.now();
				const fileNameUniq = `${timestamp}_${fileName}`;

				await this.loadlistxlsEnvEncuesta(dataConvert, 0, fileName, fileNameUniq, id_campana_envencuesta)
				// return this.spinner.hide();
				//console.log(element)

				this.gateway.get('getContPlantillasEncuestaaEnviar', {
					FILENAMEUNIQ: fileNameUniq,
					id_campana: id_campana_envencuesta,
					tipo_plantilla: 2
				}).then((result: any) => {
					let mensaje = '';
					if (result.cont == 1) {
						mensaje = `enviar 1 plantilla de encuesta`
					} else if (result.cont > 1) {
						mensaje = `enviar ${result.cont} plantillas de encuesta`
					} else {
						return this.snackbar.open(`No se encontraron clientes con los códigos de falla proporcionados en el archivo cargado.`, 'Cerrar', { duration: 10000, });
					}

					const dialogRef = this.dialog.open(ConfirmacionComponent, {
						disableClose: true,
						width: '300px',
						data: { sms: mensaje, addcomment: false }
					});

					dialogRef.afterClosed().subscribe((result) => {
						let enviado = 0
						if (result.resp) {
							this.spinner.show();
							enviado = 1;
							this.gateway.get('sendPlantillasEncuesta', {
								FILENAMEUNIQ: fileNameUniq,
								id_campana: id_campana_envencuesta,
								tipo_plantilla: 2
							}).then((result: any) => {
								this.spinner.hide();
								// this.get(this.actpage);
								this.snackbar.open(result.message, 'Cerrar', { duration: 10000, });
								this.gateway.get('confirmacionEnvioEncuesta', {
									FILENAMEUNIQ: fileNameUniq,
									IDCAMPANA: id_campana_envencuesta,
									ENVIADO: enviado
								}).then((result: any) => { });
							});
						} else {
							this.gateway.get('confirmacionEnvioEncuesta', {
								FILENAMEUNIQ: fileNameUniq,
								IDCAMPANA: id_campana_envencuesta,
								ENVIADO: enviado
							}).then((result: any) => { });
						}
					});

				});
			}
		};
		reader.readAsBinaryString(target.files[0]);
	}

	loadlistxlsEnvEncuesta(LISTA: any, cantidad: any, fileName: any, fileNameUniq: any, id_campana_envencuesta: any) {
		return new Promise(async (resolve, reject) => {
			this.spinner.show();
			let auxarr = [];
			auxarr = LISTA.slice(cantidad, cantidad + 300);
			this.gateway.save('evaluarFallasEnvEncuesta', {
				FILENAMEUNIQ: fileNameUniq,
				FILENAME: fileName,
				IDCAMPANA: id_campana_envencuesta,
				LISTA: auxarr,
				IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU,
				IDAREA: this.localSave.get('usuarioPGV').IDAREA,
				CANTIDAD: cantidad
			}).then(
				async (res) => {
					const resultado: any = res;
					if ((cantidad + 300) < LISTA.length) {
						resolve(await this.loadlistxlsEnvEncuesta(LISTA, cantidad + 300, fileName, fileNameUniq, id_campana_envencuesta))
					} else {
						this.spinner.hide();
						resolve(true);
						// this.snackbar.open('Campañas asignadas con éxito: ' + resultado.agregados + ', campañas no asignadas: ' + resultado.noagregados, 'Cerrar', { duration: 5000, });
						// this.get(this.actpage);
					}
				},
				err => {
					this.spinner.hide();
					this.snackbar.open('Las plantillas de encuestas no han sido enviadas, intente nuevamente.', 'Cerrar', { duration: 5000, });
					resolve(false);
					// console.log(err);
				}
			);
		});
	}

	convertir_a_Arreglo(data, keys) {
		// let keys = data.splice(0, 1)[0];
		// console.log(keys);
		let ret = [];
		try {
			data.forEach(element => {
				const obj: any = {};
				const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
				for (let index = 0; index < element.length; index++) {
					let aux: string = (keys[index] == null || keys[index] == undefined) ? '' : (keys[index] + '');
					let valor: string = (element[index] == null || element[index] == undefined) ? '' : (element[index] + '');
					aux = aux.toString().replace('"', '').trim();
					aux = aux.toString().replace(/'/g, "");
					aux = aux.toString().replace(/"/g, "");
					aux = aux.replace(/[\u0000-\u001F\u007F]/g, "")   // limpia caracteres invisibles
						.replace(/\\(?![nrtu"\\])/g, "/");       // reemplaza \ que no forman un escape válido

					valor = valor.toString().replace('"', '').trim();
					valor = valor.toString().replace(/'/g, "");
					valor = valor.toString().replace(/"/g, "");
					valor = valor.replace(/[\u0000-\u001F\u007F]/g, "")   // limpia caracteres invisibles
						.replace(/\\(?![nrtu"\\])/g, "/");      // reemplaza \ que no forman un escape válido

					obj[aux.toUpperCase()] = valor;
				}
				ret.push(obj);
			});
			if (ret.length && (ret[0].FALLA)) {
				return ret;
			} else {
				this.spinner.hide();
				this.snackbar.open('Archivo no válido, La columna FALLA es obligatoria.', 'Cerrar', { duration: 3000 });
				return null;
			}
		} catch (e) {
			this.spinner.hide();
			this.snackbar.open('Archivo no válido intente de nuevo.', 'Cerrar', { duration: 3000, });
			return null;
		}
	}

}

export interface Campana {
	ID_EJE: number,
	ID_CAMPANA: number,
	NOMBRE: string,
	NOMBREEJE: string,
	ESTADO: number,
	MEDIO: string,
	FECHAINICIAL: string,
	FECHAFINAL: string,
	SCRIPT: string,
	SCRIPTURL: string
}